/**
 * VARLIK DÖKÜMÜ KART SETİ (gelen karar 02.11.2026;
 * `claude/notlar/2026-11-02-varlik-dokumu-kart-seti-kararlar.md`).
 *
 * "temel": Günlük getiri, Toplam maliyet, Toplam varlık, Getiri, Mevduat
 * karşılığı — varsayılan. "ayrintili": önceki kartlar, silinmedi, Ayarlar'dan
 * seçilir. Tercih yalnızca bu cihazın `localStorage`ında (`raporGorunumu.ts`
 * ile aynı desen): bir sunum tercihi, kasaya ve merkeze yazılmaz. Depolama
 * kapalıysa ya da kayıt bozuksa temel.
 */

export type KartSeti = "temel" | "ayrintili";

export const VARSAYILAN_KART_SETI: KartSeti = "temel";

export const KART_SETI_ANAHTARI = "parafon.kartSeti";

export function kayitliKartSeti(): KartSeti {
  try {
    const v = globalThis.localStorage?.getItem(KART_SETI_ANAHTARI);
    return v === "temel" || v === "ayrintili" ? v : VARSAYILAN_KART_SETI;
  } catch {
    return VARSAYILAN_KART_SETI;
  }
}

export function kartSetiniKaydet(k: KartSeti): void {
  try {
    globalThis.localStorage?.setItem(KART_SETI_ANAHTARI, k);
  } catch {
    // Depolama kapalı: tercih oturumla sınırlı — kabul edilebilir.
  }
}
